import React from "react";
import type {ReactNode} from "react";
import {useAuth} from "../auth";
import {navigate, useRoute} from "../hooks";
import {Logo} from "./Logo";
import {OrderChatCenter, OrderChatProvider} from "./OrderChatCenter";
import {TRADER_NOTIFICATIONS} from "./notificationScope";
import {NotificationsBell} from "./NotificationsBell";

const NAV_ITEMS = [
    {path: "#/payments", label: "Payments", icon: "P"},
    {path: "#/balance", label: "Balance", icon: "B"},
    {path: "#/history", label: "History", icon: "H"},
    {path: "#/notifications", label: "Уведомления", icon: "У"},
    {path: "#/settings", label: "Настройки", icon: "Н"},
] as const;

interface AppLayoutProps {
    children: ReactNode;
}

export function AppLayout({children}: AppLayoutProps): JSX.Element {
    const {user, logout} = useAuth();
    const route = useRoute();

    return (
        <OrderChatProvider>
        <div className="app-layout trader-layout">
            <aside className="sidebar">
                {/* Колокольчик — в одной строке с названием кабинета, как у мерчанта. */}
                <div className="merchant-sidebar-head">
                    <div className="sidebar-brand merchant-brand" onClick={() => navigate("#/payments")}>
                        <Logo size={24}/>
                        <span>Payments</span>
                    </div>
                    <NotificationsBell scope={TRADER_NOTIFICATIONS}/>
                </div>
                <nav className="sidebar-nav">
                    {NAV_ITEMS.map((item) => {
                        const notifications = item.path === TRADER_NOTIFICATIONS.feedRoute;
                        return (
                            <a
                                key={item.path}
                                href={item.path}
                                className={`nav-item ${notifications ? "merchant-nav-notifications " : ""}${route.startsWith(item.path) ? "active" : ""}`}
                                aria-current={route.startsWith(item.path) ? "page" : undefined}
                                data-testid={notifications ? "merchant-nav-notifications" : undefined}
                            >
                                <span className="nav-icon">{item.icon}</span>
                                {item.label}
                            </a>
                        );
                    })}
                </nav>
                <div className="sidebar-footer merchant-sidebar-footer">
                    <div className="user-info">
                        <div className="user-avatar">
                            {(user?.login || "U")[0].toUpperCase()}
                        </div>
                        <div className="user-meta">
                            <span className="user-name">{user?.login || "unknown"}</span>
                            <span className="user-role">{user?.roles?.join(", ") || "unknown"}</span>
                        </div>
                    </div>
                    <button className="btn btn-ghost btn-sm" onClick={logout}>
                        Logout
                    </button>
                </div>
            </aside>
            <main className="main-content"><OrderChatCenter/>{children}</main>
        </div>
        </OrderChatProvider>
    );
}
